import { Navigate } from 'react-router-dom';

export default function PublicBroadcastPage() {
  return <Navigate to="/broadcast?visibility=public&status=live" replace />;
}
